<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">申请人：</span>
        </div>
        <el-select v-model="formData.personCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in responsiblePersonList" :key="item.personCode"
                     :label="item.personName" :value="item.personCode">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">加班日期：</span>
        </div>
        <el-date-picker v-model="formData.overtimeDate" type="date" format='yyyy-MM-dd' value-format="yyyy-MM-dd" size="small" style="width: 280px" placeholder="加班日期"></el-date-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">加班天数：</span>
        </div>
        <el-input v-model="formData.overtimeDays" size="small" style="width: 280px" >
          <template slot="append">天</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">加班规则：</span>
        </div>
        <el-select v-model="formData.overtimeRuleCode" size="small" style="width: 280px">
          <el-option v-for="item in overtimeRuleList" :key="item.code"
                     :label="item.ruleName" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">是否调休：</span>
        </div>
        <el-switch
          v-model="formData.isRest"
          active-text="是"
          inactive-text="否">
        </el-switch>
      </div>

      <div class="form-btn-box">
        <button-confirm value="保存" @confirm="confirm('1')" />
        <button-cancel value="保存并提交审批" @cancel="confirm('2')" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import {bus} from '../../../utils/bus'
  import {api} from '../../api/AttendancePoint'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'attendance-overtime-application-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧考勤',
          name: 'attendance-department-manage'
        }, {
          value: '加班申请'
        }],
        mainTitle: '修改加班申请',
        subheading: '',

        responsiblePersonList: [],
        overtimeRuleList: [],
        formData: {
          personCode: '',
          overtimeDate: '',
          overtimeDays: '',
          overtimeRuleCode: '',
          isRest: ''
        },

        startTimePickerOptions: {},
        endTimePickerOptions: {}
      }
    },
    created () {
      this.remoteMethod()
      this.getAttendanceOvertimeList()
      this.getOvertimeByCode()
    },
    methods: {
      remoteMethod (query) {
        this.getPersonList(query)
      },

      // 获取人员列表
      getPersonList (searchKey) {
        this.$axios.post(api.getAttendanceGroupUserList, {
          searchKey: searchKey || ''
        })
          .then(res => {
            let list = res.data.data
            this.responsiblePersonList = list
          })
          .catch(errorHandler('获取人员列表失败'))
      },

      getAttendanceOvertimeList () {
        this.$axios.post(api.getAttendanceOvertimeList, {})
          .then(res => {
            let list = res.data.data
            this.overtimeRuleList = list
          })
          .catch(errorHandler('获取加班规则失败'))
      },

      toManagementPage () {
        this.$router.push({
          name: 'attendance-overtime-application-manage'
        })
      },

      calculationTime () {
        if (this.formData.startTime && this.formData.endTime) {
          let startTime = (new Date(this.formData.startTime)).getTime()
          let endTime = (new Date(this.formData.endTime)).getTime()
          if (startTime > endTime) {
            let timeStr = startTime
            startTime = endTime
            endTime = timeStr
          }
          let timeDifference = endTime - startTime
          this.formData.hours = (timeDifference / 1000 / 3600).toFixed(2)
        }
      },

      // 查询
      getOvertimeByCode () {
        this.$axios.get(`${api.getOvertimeByCode}/${this.$route.params.id}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              this.formData = res.data.data
            }
          })
          .catch(errorHandler('查询失败'))
      },

      // 保存
      confirm (type) {
        if (!this.formData.personCode) {
          nError('请选择申请人')
          return false
        }
        if (!this.formData.overtimeDate) {
          nError('请选择加班日期')
          return false
        }
        if (!this.formData.overtimeDays) {
          nError('请输入加班天数')
          return false
        }
        if (!this.formData.overtimeRuleCode) {
          nError('请选择加班规则')
          return false
        }
        this.$axios.post(api.updateOvertime, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              let code = res.data.data
              nSuccess('保存成功')
              if (type === '1') {
                this.toManagementPage()
              } else if (type === '2') {
                this.submitOvertime(code)
              }
            }
          })
          .catch(errorHandler('保存失败'))
      },

      submitOvertime (code) {
        this.$axios.post(api.submitOvertime, {
          eventCode: code,
          sponsorAccountCode: bus.global.accountCode,
          sponsorAccountName: bus.global.accountName,
          digest: ''
        })
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('操作成功')
              this.toManagementPage()
            }
          })
          .catch(errorHandler('操作失败'))
      },

      cancel () {
        this.toManagementPage()
      }
    },
    watch: {
      'formData.startTime': {
        handler(newName, oldName) {
          this.calculationTime()
          if (this.formData.startTime) {
            let startTime = this.formData.startTime
            let startTime1 = `${startTime.split(' ')[0]} 00:00:00`
            let startTime2 = `${startTime.split(' ')[0]} 23:59:59`
            this.endTimePickerOptions = {
              disabledDate(time) {
                return time.getTime() > new Date(startTime2).getTime() || time.getTime() < new Date(startTime1).getTime()
              },
            }
          } else {
            this.endTimePickerOptions = {
              disabledDate(time) {
                return false
              },
            }
          }
        },
        deep: true
      },
      'formData.endTime': {
        handler(newName, oldName) {
          this.calculationTime()
          if (this.formData.endTime) {
            let endTime = this.formData.endTime
            let endTime1 = `${endTime.split(' ')[0]} 00:00:00`
            let endTime2 = `${endTime.split(' ')[0]} 23:59:59`
            this.startTimePickerOptions = {
              disabledDate(time) {
                return time.getTime() > new Date(endTime2).getTime() || time.getTime() < new Date(endTime1).getTime()
              },
            }
          } else {
            this.startTimePickerOptions = {
              disabledDate(time) {
                return false
              },
            }
          }
        },
        deep: true
      },
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 190px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 600px;
    padding: 0 110px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendanceOvertimeApplication/AttendanceOvertimeApplicationModify.vue